import axios, {CancelTokenSource} from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {AXIOS_CANCEL_MSG, Category,} from '../api/models';
import { ConfiguratorContext } from '../context';

interface CategoryProps {
  id?:number | undefined
  categoryId?:string | undefined
}

export const useCategory = (props: CategoryProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:CategoryProps  ) : Promise<Category | undefined> => {

    const { id, categoryId } = props;
    if (!id && !categoryId?.length ) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp =  ( id )
          ? await configurator.api.getCategory(id, cancelSource?.token)
          : await configurator.api.getCategoryByCategoryId(categoryId!, cancelSource?.token);

      cancelTokenSourceRef.current = undefined;
      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
        'getCategory',
        props
      ],
      ([_k, p]) => fetcher(p),
      {
        shouldRetryOnError: false,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        dedupingInterval:1
    }
  );
};


export default useCategory;

